import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const Container = styled.div`
  align-items: flex-start;
  border-bottom: 1px solid ${THEME.lightGrey};
  display: flex;
  flex-direction: row;
  padding: 20px 25px 20px 40px;
  flex-wrap: wrap;
`;

export const Title = styled.p`
  color: ${THEME.grey};
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  margin: 0 25px 0 0;
  padding: 2px;
`;

export const Text = styled.div`
  color: ${THEME.bobBlack};
  flex: 1;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
`;

export const Info = styled.span`
  color: ${THEME.grey};
  font-size: 14px;
  font-style: italic;
  font-weight: 500;
`;
